export default __webpack_public_path__ + "static/media/tirimzi.3a8a4c5d.jpg";